import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientesService } from 'src/app/services/clientes.service';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { environment } from '../../../environments/environment';
import { Ng2IzitoastService } from 'ng2-izitoast';

@Component({
  selector: 'app-seleccionar-paquete',
  templateUrl: './seleccionar-paquete.component.html',
  styleUrls: ['./seleccionar-paquete.component.scss']
})
export class SeleccionarPaqueteComponent implements OnInit {
  environment = environment.BASE_URL

  paquetes:any;

  respuestaGet:any;

  currentGrupo:any;
  currentCliente:any;
  currentPaquete:any;


  data:any;

  detallePaquete:any;

  nombrePaquete = '';
  descripcion = '';
  paqueteImagen = '';
  constructor(private _plataforma:ClientesService, private _activatedRoute: ActivatedRoute, 
    private _paquetes:PaquetesService, private modalService: NgbModal, private iziToast:Ng2IzitoastService,
    private router: Router) { }

  ngOnInit(): void {
    this.currentGrupo = this._activatedRoute.snapshot.paramMap.get('grupo')
    this.currentCliente = this._activatedRoute.snapshot.paramMap.get('cliente')
    this.getPaquetesGrupo();
  }

  getPaquetesGrupo(){
    this.data = {
      'grupo': this.currentGrupo,
    }

    this._plataforma.getPaquetesGrupo(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.paquetes = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.log(error));

  }

  getDetallePaquete(paquete){
    this.data = {
      'paquete':paquete
    }

    this._paquetes.getDetallePaquete(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.detallePaquete = this.respuestaGet.content;
          this.currentPaquete = paquete;
          this.nombrePaquete = this.detallePaquete[0].paquete;
          this.descripcion = this.detallePaquete[0].descripcion;
          if (this.detallePaquete[0].imagen.length == 0){
            this.paqueteImagen = '/uploads/paquete/auri.png';
          }else{
            this.paqueteImagen = this.detallePaquete[0].imagen;
          }
          document.getElementById('clickPaquete').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  seleccionarPaqueteCliente(){
    this.data = {
      'cliente': this.currentCliente,
      'grupo': this.currentGrupo,
      'paquete': this.currentPaquete,
    }

    this._plataforma.agregarPaqueteClienteV3(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success ==  '1'){
            this.iziToast.show(
              {
                  title: 'Se ha agregado el paquete correctamente.',
                  titleColor: '#f8f8ff',
                  color: '#4CAF50',
                  position: 'topRight',
                  closeOnEscape: true,
              });
            window.location.href='seleccionar-detalles/'+this.currentCliente+'/'+this.currentGrupo+'/'+this.respuestaGet.paquete_cliente;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

  async closeSesion() {
    await localStorage.removeItem('token');
    await this.router.navigate(['/']);
  }
}
